import { useLanguage } from "../context/LanguageContext";
import { useInView } from "../hooks/useInView";
import { Building2 } from "lucide-react";

const COMPANIES = [
    "PLANETA INNOVACION S.A.",
    "CAMBRA OFICIAL DE COMERC I INDUSTRIA DE VALLS",
    "AUGUSTA ABOGADOS",
    "BUFETE ESCURA S.L.P.",
    "ILUSTRE COLEGIO DE ODONTOLOGOS Y ESTOMATOLOGOS",
    "GAUGER Y ASOCIADOS S.L.U.",
];

export default function TrustedCompanies() {
    const { t } = useLanguage();
    const [ref, inView] = useInView();

    return (
        <section
            className="py-16 md:py-24 px-6 border-b border-slate-100 dark:border-slate-800/50"
            ref={ref}
            data-testid="companies-section"
        >
            <div className={`max-w-7xl mx-auto ${inView ? "animate-fade-in-up" : "opacity-0"}`}>
                <p className="text-center text-sm font-medium text-slate-500 dark:text-slate-400 uppercase tracking-widest mb-10">
                    {t.companies.title}
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {COMPANIES.map((company) => (
                        <div
                            key={company}
                            className="flex items-center gap-3 p-5 bg-white dark:bg-slate-900/50 border border-slate-100 dark:border-slate-800 rounded-xl hover:shadow-md hover:border-slate-200 dark:hover:border-slate-700 transition-all duration-300"
                            data-testid="company-card"
                        >
                            <div className="w-10 h-10 rounded-lg bg-blue-50 dark:bg-blue-900/20 flex items-center justify-center flex-shrink-0">
                                <Building2 className="w-5 h-5 text-blue-600 dark:text-blue-400" />
                            </div>
                            <span className="text-sm font-medium leading-tight">{company}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
